import React from 'react';
import Icon from '@mdi/react';
import {
  mdiTrashCanOutline,
  mdiFileDocumentEditOutline,
  mdiContentCopy,
  mdiDotsHorizontalCircleOutline,
  mdiContentSaveOutline,
  mdiPlusCircle,
  mdiPencil,
  mdiPlusBoxOutline,
  mdiRestore,
  mdiHistory,
} from '@mdi/js';
import './ActionsMenu.scss';
import DrainIcon from '../../../../../src/assets/images/drain.svg';
import BlockIcon from '../../../../../src/assets/images/block.svg';
import { observer } from 'mobx-react';
import { graphTimeSeries24 } from "@esri/calcite-ui-icons";

interface IActionsMenuProps {
  i?: any;
  item: any;
  elementActions: any;
  children?: string;
  disabled?: boolean;
  hideIcon?: boolean;
  colorWhite?: boolean
}

export const ActionsMenu = observer((props: IActionsMenuProps) => {
  const { i = '1', item, elementActions, children, disabled = false, colorWhite } = props;

  // Don't render anything if there are no actions
  if (Object.keys(elementActions).length === 0) {
    return null;
  }

  const icons = {
    Copy: mdiContentCopy,
    Edit: mdiFileDocumentEditOutline,
    Delete: mdiTrashCanOutline,
    Save: mdiContentSaveOutline,
    Discard: mdiTrashCanOutline,
    Add: mdiPlusCircle,
    'S/V/C-WSC': mdiPencil,
    'Insert Station': mdiPlusBoxOutline,
    'Delete Station': mdiTrashCanOutline,
    'Reset Reach - WSC': mdiRestore,
    'Reset Reach': mdiRestore,
    'Reset Fixed Depth': mdiRestore,
    'Reset Fixed Width': mdiRestore,
    'Update Lining Material': mdiHistory,
    'Cross Section Tool': graphTimeSeries24,
    'Add Drain': mdiPlusBoxOutline,
    'Edit Drain': mdiPencil,
    'Add Block': mdiPlusBoxOutline,
    'Edit Block': mdiPencil,
    'Delete Block': mdiTrashCanOutline,
    'Delete Drain': mdiTrashCanOutline,
    'Match Vertex': props.hideIcon ? undefined : mdiPencil,
    'Edit Template': mdiPencil,
    'Update Curve Value': mdiPencil,
    'Add Fixture': mdiPlusBoxOutline,
    'Edit Fixture': mdiPencil,
    'Delete Fixture': mdiTrashCanOutline,
    'Edit Pipe': mdiPencil,
    'Edit Pipeline': mdiPencil,
  };

  return (
    <div
      className={`actions-button ${disabled ? 'disabled' : ''}`}
      id={'actions-button-' + i}
      onClick={() => {
        if (disabled) return;
        // removes focus on click
        const el = document.getElementById('actions-button-' + i);
        el?.blur();
      }}
    >
      <button className={`usa-button usa-button--unstyled text-no-underline${colorWhite ? ' white-text' : ''}`} disabled={disabled}>
        <Icon path={mdiDotsHorizontalCircleOutline} title="Actions" size={1.2} className={`mx-1 ${disabled ? 'disabled' : ''}`} />
        {children}
      </button>
      {!disabled && (
        <div className="actions-menu">
          {Object.keys(elementActions).map((key) => (
            <button
              key={key}
              data-testid={`action-${key}-${i}`}
              className="usa-button usa-button--unstyled actions-menu-item"
              onClick={elementActions[key].disabled ? undefined : (e) => {
                (document.activeElement as HTMLElement)?.blur();
                elementActions[key].action(e, item, i);
              }}
              disabled={elementActions[key].disabled}
            >
              {typeof icons[key] === 'string' && (icons[key] === DrainIcon || icons[key] === BlockIcon) ? (
                <img src={icons[key]} alt={key} style={{ width: '20px', height: '20px', marginRight: '8px' }} />
              ) : icons[key] ? (
                <Icon path={icons[key]} title={key} size={0.9} style={{ marginRight: '8px' }} className="menu-icon" />
              ) : null}
              <span>{key}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
});
